import apiClient from "../../axios/apiClient";
import { logout } from "./AuthActions";

export const getUserList =
  (token, limit = 10, page = 1, search = "", sort = "desc",filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-List`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters:filters
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERLIST_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERLIST_REJECTED",
        payload: error.response,
      });
    }
  };

  export const getActiveUserList =
  (token, limit = 10, page = 1, search = "", sort = "desc",filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Active-User-List`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters:filters
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERLIST_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERLIST_REJECTED",
        payload: error,
      });
    }
  };

  export const getInactiveUserList =
  (token, limit = 10, page = 1, search = "", sort = "desc",filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Inactive-User-List`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters:filters
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERLIST_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERLIST_REJECTED",
        payload: error.response,
      });
    }
  };

  export const saveUserData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_USER_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-User`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_USER_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_USER_REJECTED", payload: error.response });
    }
  };
  

  export const getUserListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Edit-User/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERLISTBYID_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getUserFeeStructureById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USER_FEE_STRUCTURE_BY_ID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-Fee-Structure-List/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let payload = response.data?.data;
      if (payload && !Array.isArray(payload)) {
        payload = [payload];
      }
      if (!payload) {
        payload = [];
      }
      
      dispatch({
        type: "GET_USER_FEE_STRUCTURE_BY_ID_FULFILLED",
        payload: payload,
        userCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USER_FEE_STRUCTURE_BY_ID_REJECTED",
        payload: error.response,
      });
    }
  };

export const getUserFeeStructureList =
  (token, limit = 10, page = 1, search = "", sort = "desc", filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USER_FEE_STRUCTURE_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-Fee-Structure-List`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters: filters
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USER_FEE_STRUCTURE_LIST_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USER_FEE_STRUCTURE_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateUserData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_USER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-User/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USER_REJECTED", payload: error.response });
  }
};

export const updateUserStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_USER_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-User-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USER_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteUserData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_USER_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-User/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USER_REJECTED", payload: error.response });
  }
};

export const addUserFeeStructure = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_USER_FEE_STRUCTURE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Add-User-Fee-Structure`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_USER_FEE_STRUCTURE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_USER_FEE_STRUCTURE_REJECTED", payload: error.response });
  }
};

export const updateUserFeeStructure = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USER_FEE_STRUCTURE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-User-Fee-Structure/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_FEE_STRUCTURE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USER_FEE_STRUCTURE_REJECTED", payload: error.response });
  }
};

export const deleteUserFeeStructure = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_USER_FEE_STRUCTURE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-User-Fee-Structure/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USER_FEE_STRUCTURE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USER_FEE_STRUCTURE_REJECTED", payload: error.response });
  }
};


export const resendEmailConfirmationId =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "RESEND_EMAIL_CONFIRMATION_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Resend-Mail/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "RESEND_EMAIL_CONFIRMATION_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "RESEND_EMAIL_CONFIRMATION_REJECTED",
        payload: error.response,
      });
    }
  };



export const logoutUserDevice =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "LOGOUT_USER_DEVICE_PENDING" });
      const data={
        "status":"Active"
      }
      const response = await apiClient.post(
        `/api/admin/v1/Logout-User/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "LOGOUT_USER_DEVICE_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "LOGOUT_USER_DEVICE_REJECTED",
        payload: error.response,
      });
    }
  };